<template>
  <advance-charge-info ref="advanceChargeInfo" :context="context" :action="action" :adjust="adjust" :view-source="viewSource" :location="location" />
</template>

<script>
import AdvanceChargeInfo from './advanceChargeInfo'

export default {
  name: 'TabAdvanceCharge',
  components: { AdvanceChargeInfo },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    adjust: { type: Boolean, required: false, default: false },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    location: { type: String, required: false }
  },
  data() {
    return { }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        return
      }
      // 调用子组件
      this.$refs.advanceChargeInfo.onShow(row, isRefresh)
    },
    getSubmitData() {
      return this.$refs.advanceChargeInfo.getSubmitData()
    }
  }
}
</script>

<style>
</style>
